<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <!-- Breadcrumb and Buttons Section -->
                <div class="d-flex flex-wrap justify-content-between">
                    <div class="breadcrumbactive">
                        <div>
                            <span>Campaigns</span>
                            <div>Preview Campaign</div>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap align-items-center">
                        <button type="button" class="btn btn-smm btn-default ml-3"
                            v-if="this.$route.query.from_approval_email"
                            style="border-radius: 5px !important;height: 32px !important;" @click="goToCreateCampaign('approval')">
                            <i class="icon icon-arrow-left fs-12 text-black"></i>
                            Back
                        </button>
                        <button type="button" class="btn btn-smm btn-default ml-3"
                            v-else
                            style="border-radius: 5px !important;height: 32px !important;" @click="goToCreateCampaign('not_approval')">
                            <i class="icon icon-arrow-left fs-12 text-black"></i>
                            Back
                        </button>
                        <div v-if="approveButtonDisable == false">
                            <button type="button" class="btn new-save-button ml-3" v-if="!this.$route.query.from_approval_email"
                                style="width: 180px !important;height: 32px !important;" @click="previewTempThreeData">
                                Send for Approval
                            </button>
                        </div>
                        <div v-else>
                            <button class="btn new-save-button ml-3" disabled style="position: relative;width: 180px !important;height: 32px !important;">Send for Approval
                                <hollow-dots-spinner style="position: absolute;margin: 0;top: 20px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                            </button>
                        </div>
                    </div>
                </div>
            </h2>
            <div class="start-overflow">
                <div class="create-company-container w-100">
                    <div class="main-div">
                        <div class="create-company-header d-flex align-items-center justify-content-between">
                            <span class="fs-14  pl-4 text-white ml-8 fw-500">Template Preview</span>
                        </div>
                        <!-- Template Information Section -->
                        <div v-if="email_template_data.is_customized == false" >
                            <div v-for="(data, template_index) in email_template_data.template_details" class="mt-6 px-10" :key="template_index">
                                <div class="pt-6 pl-6 pr-6 pb-2 mx-auto">
                                    <table role="presentation"
                                        style="width:100%;border-collapse:collapse;border:0;border-spacing:0;background:#fff;">
                                        <tr>
                                            <td align="center" style="padding:0px;">
                                                <table role="presentation"
                                                    style="width:602px;border-collapse:collapse;border:1px solid #cccccc;border-spacing:0;text-align:left;background: #f5f5fa;">
                                                    <tr v-if="data.logoImage.length">
                                                        <td align="center" style="padding:20px 0 20px 0;"
                                                            v-for="(logo,index) in data.logoImage" :key="index">
                                                            <img :src=logo.url width="150"
                                                                style="height:auto;display:block;" />
                                                        </td>
                                                    </tr>
                                                    <!-- <tr v-else class="text-center pt-50 fw-500 fs-16">No Logo Image</tr> -->
                                                    <tr>
                                                        <td align="center"
                                                            style="padding: 4px 4px 16px 2px;color: #000000;text-transform: capitalize;font-size: 20px;">
                                                            {{ data.topic_name }}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="data.bannerImage.length">
                                                        <td align="center" style="background:#f5f5fa;"
                                                            v-for="(banner_image,index) in data.bannerImage"
                                                            :key="index">
                                                            <img :src=banner_image.url width="520"
                                                                style="height:auto;display:block;" />
                                                        </td>
                                                    </tr>
                                                    <!-- <tr v-else class="text-center pt-50 fw-500 fs-16">No Banner Image</tr> -->
                                                    <tr>
                                                        <td style="padding:30px 41px 20px 41px;">
                                                            <table role="presentation"
                                                                style="width:100%;border-collapse:collapse;border:0;border-spacing:0;">
                                                                <tr>
                                                                    <td style="padding:0 0 10px 0;color:#153643;">
                                                                        <h1
                                                                            style="font-size:25px;margin:0 0 20px 0;color: #000000;text-align: center;text-transform: capitalize;">
                                                                            {{ data.headline }}</h1>
                                                                        <p
                                                                            style="margin:0 0 12px 0;font-size:16px;line-height:24px;color: #000000;max-width: 520px;overflow-wrap: break-word;">
                                                                            {{ data.content }}
                                                                        </p>
                                                                        <p v-if="data.add_url && data.headline_url"
                                                                            style="margin:35px 0px 20px;font-size:18px;line-height:24px;text-align: center;">
                                                                            <button style="font-size:18px;font-weight: 600;text-decoration:none;text-transform: capitalize !important;padding: 12px 20px;color: #fff;background-color: #0475f3;border-radius: 6px;">
                                                                                {{ data.headline_url }}
                                                                            </button>
                                                                        </p>
                                                                    </td>
                                                                </tr>
                                                                <!-- <tr>
                                                                    <td style="padding:0;">
                                                                        <table role="presentation" style="width:100%;border-collapse:collapse;border:0;border-spacing:0;">
                                                                            <tr>
                                                                                <td style="width:260px;padding:0;vertical-align:top;color:#153643;">
                                                                                    <p style="margin:0 0 25px 0;font-size:16px;line-height:24px;"><img src="https://assets.codepen.io/210284/left.gif" alt="" width="260" style="height:auto;display:block;" /></p>
                                                                                    <p style="margin:0 0 12px 0;font-size:16px;line-height:24px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. In tempus adipiscing felis, sit amet blandit ipsum volutpat sed. Morbi porttitor, eget accumsan dictum, est nisi libero ultricies ipsum, in posuere mauris neque at erat.</p>
                                                                                    <p style="margin:0;font-size:16px;line-height:24px;"><a href="http://www.example.com" style="color:#ee4c50;text-decoration:underline;">Blandit ipsum volutpat sed</a></p>
                                                                                </td>
                                                                                <td style="width:20px;padding:0;font-size:0;line-height:0;">&nbsp;</td>
                                                                                <td style="width:260px;padding:0;vertical-align:top;color:#153643;">
                                                                                    <p style="margin:0 0 25px 0;font-size:16px;line-height:24px;"><img src="https://assets.codepen.io/210284/right.gif" alt="" width="260" style="height:auto;display:block;" /></p>
                                                                                    <p style="margin:0 0 12px 0;font-size:16px;line-height:24px;">Morbi porttitor, eget est accumsan dictum, nisi libero ultricies ipsum, in posuere mauris neque at erat. Lorem ipsum dolor sit amet, consectetur adipiscing elit. In tempus adipiscing felis, sit amet blandit ipsum volutpat sed.</p>
                                                                                    <p style="margin:0;font-size:16px;line-height:24px;"><a href="http://www.example.com" style="color:#ee4c50;text-decoration:underline;">In tempus felis blandit</a></p>
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </td>
                                                                </tr> -->
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="data.location.street || data.location.city || data.location.township || data.location.state || data.location.country || data.location.zip_code || data.facebook_url || data.insta_url || data.twitter_url || data.linkedin_url || data.phone_number.number">
                                                        <td style="padding:30px;background:#fff;">
                                                            <table role="presentation"
                                                                style="width:100%;border-collapse:collapse;border:0;border-spacing:0;font-size:9px;">
                                                                <tr>
                                                                    <td style="padding:0;width:50%;" align="left">
                                                                        <p v-if="data.location.street || data.location.city || data.location.township || data.location.state || data.location.country || data.location.zip_code" style="margin:0;font-size:14px;line-height:16px;color:#454444;font-weight: 800;">
                                                                            Address:
                                                                        </p><br>
                                                                        <p
                                                                            style="margin:0;font-size:14px;line-height:16px;color:#454444;font-weight: 600;">
                                                                            {{ data.location.street || ""}} <span v-if="data.location.street">,</span>
                                                                            {{ data.location.city || ""}} <span v-if="data.location.city">,</span>
                                                                        </p><br>
                                                                        <p
                                                                            style="margin:0;font-size:14px;line-height:16px;color:#454444;font-weight: 600;">
                                                                            {{ data.location.township || ""}} <span v-if="data.location.township">,</span>
                                                                            {{ data.location.state || ""}} <span v-if="data.location.state">,</span>
                                                                        </p><br>
                                                                        <p
                                                                            style="margin:0;font-size:14px;line-height:16px;color:#454444;font-weight: 600;">
                                                                            {{ data.location.country || ""}} <span v-if="data.location.zip_code">-</span>
                                                                            {{ data.location.zip_code || "" }}
                                                                        </p>
                                                                        <p
                                                                            style="padding-top: 12px;font-size:14px;line-height:16px;color:#454444;font-weight: 600;" v-if="data.phone_number.number">
                                                                            Phone <span>: </span>
                                                                            {{ data.phone_number.code }} {{ data.phone_number.number }}
                                                                        </p>
                                                                    </td>
                                                                    <td style="padding:0;width:50%;" align="right">
                                                                        <table role="presentation"
                                                                            style="border-collapse:collapse;border:0;border-spacing:0;">
                                                                            <tr>
                                                                                <td v-if="data.facebook_url" style="padding:0 0 0 10px;width:30px;">
                                                                                    <!-- <a :href=email_template_data.facebook_url
                                                                                        style="color:#ffffff;">-->
                                                                                        <img
                                                                                            src="/static/images/template-three-facebook.png"
                                                                                            alt="Facebook" width="30"
                                                                                            style="height:auto;display:block;border:0;" />
                                                                                        <!-- </a> -->
                                                                                </td>
                                                                                <td v-if="data.insta_url" style="padding:0 0 0 10px;width:30px;">
                                                                                    <!-- <a :href=email_template_data.insta_url
                                                                                        style="color:#ffffff;"> -->
                                                                                        <img
                                                                                            src="/static/images/template-three-instagram.png"
                                                                                            alt="Instagram" width="30"
                                                                                            style="height:auto;display:block;border:0;" />
                                                                                        <!-- </a> -->
                                                                                </td>
                                                                                <td v-if="data.twitter_url" style="padding:0 0 0 10px;width:30px;">
                                                                                    <!-- <a :href=email_template_data.twitter_url
                                                                                        style="color:#ffffff;"> -->
                                                                                        <img
                                                                                            src="/static/images/template-three-twitter.png"
                                                                                            alt="Twitter" width="30"
                                                                                            style="height:auto;display:block;border:0;" />
                                                                                        <!-- </a> -->
                                                                                </td>
                                                                                <td v-if="data.linkedin_url" style="padding:0 0 0 10px;width:30px;">
                                                                                    <!-- <a :href=email_template_data.linkedin_url
                                                                                        style="color:#ffffff;"> -->
                                                                                        <img
                                                                                            src="/static/images/template-three-linkedin.png"
                                                                                            alt="Linkedin" width="30"
                                                                                            style="height:auto;display:block;border:0;" />
                                                                                        <!-- </a> -->
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="d-flex align-items-center justify-content-center mt-4 mb-4" v-if="ajaxCallInProgress">
                                <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div v-for="(temp_data, temp_index) in email_template_data.template_details" class="col-lg-4 col-md-4 col-sm-12 pr-10 pl-10" :key="temp_index">
                                    <div class="text-center pt-4 pb-4">
                                        <div @click="viewTemplate(temp_data)" class="pointer card-border pb-2">
                                            <h6 class="text-truncate max-width text-capitalize">{{ temp_data.topic_name ? temp_data.topic_name : temp_data.info.topic_name }}</h6>
                                            <img :src="temp_data.bannerImage ? temp_data.bannerImage[0].url : temp_data.images.banner_image" alt="#" class="img" width="80%" height="200px">
                                            <h5 class="text-truncate max-width text-capitalize">{{ temp_data.headline ? temp_data.headline : temp_data.info.headline_name }}</h5>
                                            <p class="text-truncate max-width">{{ temp_data.content ? temp_data.content : temp_data.info.headline_content }}</p>
                                            <button class="btn preview-btn text-truncate text-capitalize">{{ temp_data.headline_url ? temp_data.headline_url : temp_data.info.url_headline }}</button>
                                        </div>
                                        <div v-if="temp_data.template_dates">
                                            (<span v-for="(temp_date, temp_date_index) in temp_data.template_dates" :key="temp_date_index">{{temp_date}}<span v-if="temp_date_index != (temp_data.template_dates.length -1)">; </span></span>)
                                        </div>
                                        <div v-else>
                                            (<span v-for="(temp_date, temp_date_index) in temp_data.email_dates" :key="temp_date_index">{{temp_date}}<span v-if="temp_date_index != (temp_data.email_dates.length -1)">; </span></span>)
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Buttons Section -->
                        <div class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-5" v-if="this.$route.query.from_approval_email && userPermissions.campaigns.permitted_actions.approval && ajaxCallInProgress == false">
                            <button v-if="campaign_status != 'rejected'" class="btn new-cancel-button" :disabled="openApprove == true || openRejectPopUp == true" :class="{'border-none':(openApprove == true || openRejectPopUp == true)}" @click ="rejectPopUp">Reject</button>
                            <button class="btn new-save-button ml-5" :disabled="openApprove == true || openRejectPopUp == true" @click ="approvePopUp">Approve</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <view-template-pop-up v-if="showPreviewTemplatePopUp" modal_name="ViewTemplatePopUp" :template_data="template_data" @hidePreviewTemplatePopUp="hidePreviewTemplatePopUp"></view-template-pop-up>
        <approve-campaign v-if="openApprovePopUp" modal_name="approveCampaign" @approveCampaigns="approveCampaigns" @cancelApprove="closeApprove"></approve-campaign>
        <reject-campaign v-if="openRejectPopUp" modal_name="rejectCampaign" @rejectCampaigns="rejectCampaigns" @cancelReject="closeReject"></reject-campaign>
        <expired-campaign-alert v-if="showExpiredCampaign" modal_name="expiredCampaign" @rejectExpiredCampaigns="rejectExpiredCampaigns" @closeExpiredCampaign="closeExpiredCampaign"></expired-campaign-alert>
        <approve-popup v-if="openApprove" modal_name="approve-popup" @cancelApproval="cancelApproval" @ApproveActivity="approveCampaigns"></approve-popup>
        <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}
        </sweet-modal>
        <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}
        </sweet-modal>
    </div>
</template>
<script>
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import campaign from "../../mixins/campaign.js";
    import ApproveCampaign from "../../alertModals/ApproveCampaign";
    import RejectCampaign from "../../alertModals/RejectCampaign";
    import { EventBus } from '../../eventBus/nav-bar-event.js';
    import ApprovePopup from "./ApprovePopup"
    import ExpiredCampaignAlert from "./ExpiredCampaignAlert"
    import ViewTemplatePopUp from "./ViewTemplatePopUp"
    import { HollowDotsSpinner } from "epic-spinners";
    import { HalfCircleSpinner } from "epic-spinners";
    export default {
        data() {
            return {
                ajaxCallInProgress: false,
                showPreviewTemplatePopUp: false,
                template_data : [],
                approveButtonDisable: false,
                openApprovePopUp: false,
                openApprove: false,
                openRejectPopUp: false,
                success_msg: '',
                warning_msg: '',
                email_template_data: {},
                temp_template_details: [],
                campaign_status: '',
                can_reject: false,
                showExpiredCampaign: false,
            }
        },
        components: {
            SweetModal,
            ApproveCampaign,
            RejectCampaign,
            HollowDotsSpinner,
            HalfCircleSpinner,
            ApprovePopup,
            ViewTemplatePopUp,
            ExpiredCampaignAlert,
        },
        mixins: [campaign],
        methods: {
            //Fetches template data to respective fields
            viewTemplate(data){
                if(this.$route.query.from_approval_email){
                    let logo = []
                    let banner_image = []
                    logo.push({
                        url: data.images.logo})
                    banner_image.push({
                        url: data.images.banner_image})
                    let formatted_data = {
                        add_url: data.info.url,
                        bannerImage: banner_image,
                        content: data.info.headline_content,
                        facebook_url: data.social_media.facebook,
                        headline: data.info.headline_name,
                        headline_url: data.info.url_headline,
                        insta_url: data.social_media.instagram,
                        linkedin_url: data.social_media.linkedin,
                        location: data.address,
                        logoImage: logo,
                        phone_number: data.phone_number,
                        template_dates: data.email_dates,
                        topic_name: data.info.topic_name,
                        twitter_url: data.social_media.twitter
                    }
                    this.template_data = formatted_data
                }else{
                    this.template_data = data;
                }
                this.showPreviewTemplatePopUp = true;
                setTimeout(() => {
                    this.$modal.show("ViewTemplatePopUp");
                }, 500);
            },
            hidePreviewTemplatePopUp(){
                this.showPreviewTemplatePopUp = false;
            },
            cancelApproval(){
                this.openApprove = false
            },
            //Redirects to create or approve or preview page
            goToCreateCampaign(obj){
                if(obj == 'approval'){
                    if(this.$route.params.id){
                        this.$router.push("/campaign/email/approveEmail/" + this.$route.params.id)
                    } else {
                        this.$router.push("/campaign/email/createCampaignEmail")
                    }
                } else {
                    if(this.$route.params.id){
                        this.$router.push("/campaign/email/editCampaignEmail/" + this.$route.params.id)
                    } else {
                        this.$router.push("/campaign/email/createCampaignEmail")
                    }
                    setTimeout(() => {
                        EventBus.$emit("back_from_preview_campaign")
                    }, 1000);
                }
            },
            //API call to create campaign
            async previewTempThreeData() {
                this.approveButtonDisable = true
                let temp_data = []
                let temp_template_details = []
                if (this.$route.params.id) {
                    this.email_template_data.recipient_details.forEach((el) => {
                        if(el.phone.phone_number == "" || el.phone.phone_number){
                            temp_data.push({
                                email: el.email,
                                name: el.name,
                                phone: el.phone.phone_number,
                                id: el.id,
                                source: el.source
                            })
                        } else {
                            temp_data.push({
                                email: el.email,
                                name: el.name,
                                phone: el.phone,
                                id: el.id,
                                source: el.source
                            })
                        }
                    })
                } else {
                    this.email_template_data.recipient_details.forEach((el) => {
                        temp_data.push({
                            email: el.email,
                            name: el.name,
                            phone: el.phone.phone_number,
                            id: el.id,
                            source: el.source
                        })
                    })
                }
                if(this.email_template_data.attachments){
                    this.email_template_data.attachments.forEach((att, att_index) =>{
                        delete att['created_time']
                        delete att['error']
                        delete att['progress']
                        delete att['uploading']
                    })
                }
                this.email_template_data.template_details.forEach((el, el_index) => {
                    temp_template_details.push({
                        email_dates: el.template_dates,
                        address: {
                            address_type: 'mailing_address',
                            building_number: '',
                            city: el.location.city,
                            country: el.location.country,
                            street: el.location.street,
                            latitude: 20,
                            longitude: 77,
                            state: el.location.state,
                            township: el.location.township,
                            zip_code: el.location.zip_code
                        },
                        phone_number: el.phone_number,
                        info: {
                            headline_content: el.content,
                            headline_name: el.headline,
                            topic_name: el.topic_name,
                            url: el.add_url,
                            url_headline: el.headline_url
                        },
                        social_media: {
                            facebook: el.facebook_url,
                            instagram: el.insta_url,
                            linkedin: el.linkedin_url,
                            twitter: el.twitter_url
                        },
                        images: {
                            banner_image: el.bannerImage.length ? el.bannerImage[0].url : '',
                            logo: el.logoImage.length ? el.logoImage[0].url : ''
                        },
                    })
                })
                try {
                    let params = {
                        "budget": {
                            "symbol": this.email_template_data.currency,
                            "value": this.email_template_data.budget
                        },
                        "description": this.email_template_data.description,
                        "start_date": this.email_template_data.start_date,
                        "start_time": this.email_template_data.start_time,
                        "end_date": this.email_template_data.end_date,
                        "send_now": this.email_template_data.send_now,
                        "is_customized": this.email_template_data.is_customized,
                        "message_details": {
                            "message": "",
                            "url": "picture.com"
                        },
                        "name": this.email_template_data.campaign_name,
                        "recipients": temp_data,
                        "other_recipients": this.email_template_data.other_recipients,
                        "recurrence": this.email_template_data.recurrence_days.toLowerCase(),
                        "template_details": temp_template_details,
                        "attachments": this.email_template_data.attachments,
                        "template_type": "advertised_yours",
                        "type": "email",
                        "id": this.$route.params.id || ""
                    }
                    if (this.$route.params.id) {
                        var response = await this.updateCampaignsByID(params)
                    } else {
                        var response = await this.createCampaignData(params)
                    }
                    if (response.status_id == 1) {
                        this.success_msg = response.message
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            localStorage.removeItem("email_template_data")
                            this.$router.push({
                                path: '/campaign/email/campaignEmailListView/'
                            })
                            this.$refs.success_modal.close();
                        }, 3000);
                    } else {
                        this.warning_msg = response.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                            this.approveButtonDisable = false;
                        }, 3000);
                    }
                } catch (error) {
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                        this.approveButtonDisable = false;
                    }, 3000);
                }
            },
            //API call to get campaign data based on id
            async getApprovalDetails(){
                this.ajaxCallInProgress = true;
                let response = await this.getCampaignDetails(this.$route.params.id);
                this.email_template_data = response.response
                this.can_reject = this.email_template_data.can_reject
                let bannerImage = []
                let logoImage = []
                if(this.email_template_data.template_details.length == 1){
                    bannerImage.push({
                        url: this.email_template_data.template_details[0].images.banner_image
                    })
                    logoImage.push({
                        url: this.email_template_data.template_details[0].images.logo
                    })
                    this.temp_template_details.push({
                        template_dates: this.email_template_data.template_details[0].email_dates,
                        topic_name: this.email_template_data.template_details[0].info.topic_name,
                        headline_url: this.email_template_data.template_details[0].info.url_headline,
                        add_url: this.email_template_data.template_details[0].info.url,
                        headline: this.email_template_data.template_details[0].info.headline_name,
                        content: this.email_template_data.template_details[0].info.headline_content,
                        phone_number: this.email_template_data.template_details[0].phone_number,
                        location: this.email_template_data.template_details[0].address,
                        facebook_url: this.email_template_data.template_details[0].social_media.facebook,
                        insta_url: this.email_template_data.template_details[0].social_media.instagram,
                        linkedin_url: this.email_template_data.template_details[0].social_media.linkedin,
                        twitter_url: this.email_template_data.template_details[0].social_media.twitter,
                        bannerImage: bannerImage,
                        logoImage: logoImage,
                    })
                    this.email_template_data.template_details = []
                    this.email_template_data.template_details = this.temp_template_details
                }
                this.ajaxCallInProgress = false;
                this.$forceUpdate();
            },
            //Shows reject popup
            rejectPopUp(){
                if(this.can_reject == true){
                    this.showExpiredCampaign = true;
                    setTimeout(()=>{
                        this.$modal.show("expiredCampaign")
                    },500)
                } else {
                    this.openRejectPopUp = true;
                    setTimeout(()=>{
                        this.$modal.show("rejectCampaign")
                    },500)
                }
            },
            closeReject(){
                this.openRejectPopUp = false;
            },
            closeExpiredCampaign(){
                this.showExpiredCampaign = false;
            },
            //API call to reject expired campaign
            async rejectExpiredCampaigns(){
                try {
                    let params = {
                        campaign_id: this.$route.params.id,
                        status: "rejected",
                        reason: "Please ask creator to edit start date & resend for approval"
                    }
                    let response = await this.callApproveRejectCampaignAPI(params)
                    if (response.status_id == 1) {
                        this.success_msg = response.response
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.closeExpiredCampaign();
                            this.$router.push({
                                path: '/campaign/email/campaignEmailListView/'
                            })
                            this.$refs.success_modal.close();
                        }, 3000);
                    } else {
                        this.warning_msg = response.reason
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }catch(error){
                    this.warning_msg = error.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            },
            //API call to approve campaign
            async approveCampaigns(reason){
                try{
                    let params = {
                        campaign_id: this.$route.params.id,
                        status: "approved",
                        reason: reason
                    }
                    let response = await this.callApproveRejectCampaignAPI(params)
                    if (response.status_id == 1) {
                        this.success_msg = response.response
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.closeApprove();
                            this.$router.push({
                                path: '/campaign/email/campaignEmailListView/'
                            })
                            this.$refs.success_modal.close();
                        }, 3000);
                    } else {
                        this.warning_msg = response.reason
                        this.closeApprove();
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }catch(error){
                    this.warning_msg = error.reason
                    this.closeApprove();
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            },
            //API call to reject campaign
            async rejectCampaigns(reason){
                try {
                    let params = {
                        campaign_id: this.$route.params.id,
                        status: "rejected",
                        reason: reason
                    }
                    let response = await this.callApproveRejectCampaignAPI(params)
                    if (response.status_id == 1) {
                        this.success_msg = response.response
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.closeReject();
                            this.$router.push({
                                path: '/campaign/email/campaignEmailListView/'
                            })
                            this.$refs.success_modal.close();
                        }, 3000);
                    } else {
                        this.warning_msg = response.reason
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }catch(error){
                    this.warning_msg = error.reason
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            },
            approvePopUp(){
                this.openApprove = true;
                setTimeout(() => {
                    this.$modal.show('approve-popup');
                }, 500);


                // this.openApprovePopUp = true;
                // setTimeout(()=>{
                //     this.$modal.show("approveCampaign")
                // },500)
            },
            closeApprove(){
                this.openApprovePopUp = false;
            },
        },
        mounted() {
            if(this.$route.query.from_approval_email){
                this.getApprovalDetails()
            }
            if(localStorage.getItem("email_template_data")){
                this.email_template_data = JSON.parse(localStorage.getItem("email_template_data"))
            }
            this.$forceUpdate();
        },
        computed : {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            userPermissions(){
                return this.$store.getters.userPermissions;
            }
        }
    }
</script>
<style scoped>
    .border-none{
        border: none !important;
    }
    .add-new-field {
        background-color: transparent;
        outline: 0 none !important;
    }

    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-container {
        background-color: #fff;
        padding: 0px 0 0px 0;
        border-radius: 5px;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }

    .btn-new-cancel {
        color: #fff;
        background-color: #E64646;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #E64646;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-save {
        border: 2px solid #1f8122;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #1f8122;
        text-transform: capitalize;
    }
    .preview-btn{
        background-color: #00448b;
        color: #fff;
        border-radius: 6px;
        margin-bottom: 8px;
        max-width: 150px !important;
    }
    .card-border{
        border: 6px dashed lightgray;
        border-radius: 6px;
    }
    .max-width{
        max-width: 380px !important;
        white-space: pre-wrap;
        word-wrap: break-word;
        padding-left: 10px;
        padding-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Campaign/Email/PreviewTemplateThree.vue